import cn from 'classnames';
import React from 'react';

import { ButtonV3 } from 'components/ComponentV2';

import styles from './SectionWrapper.module.scss';

export interface SectionWrapperProps {
  /** Custom class name */
  className?: string;
  /** Header title */
  title: string;
  /** Header description */
  description: string;
  /** Header details */
  subDetails?: React.ReactNode;
  /** Add Button Label */
  addButtonLabel?: string;
  /** Helper text */
  helperText?: string;
  /** Add handler */
  onAdd?: () => void;
  /** children for content */
  children: React.ReactNode;
  /** Custom class name for content */
  contentClassName?: string;
  hasData?: boolean;
  buttonClassName?: string;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  addButtonLabel,
  title,
  description,
  subDetails,
  onAdd,
  children,
  contentClassName,
  hasData,
  helperText,
  className,
  buttonClassName,
}: SectionWrapperProps) => {
  return (
    <div className={cn(styles.MainSection, className)}>
      <div className={styles.MainSectionHeader}>
        <p className={styles.MainSectionHeaderTitle}>
          {title}
          {helperText && (
            <span className={styles.MainSectionHeaderHelperText}>
              {helperText}
            </span>
          )}
        </p>
        <p className={styles.MainSectionHeaderDescription}>{description}</p>
        {subDetails ? subDetails : null}
      </div>
      <div className={cn(styles.MainSectionContent, contentClassName)}>
        {children}
        {addButtonLabel ? (
          <ButtonV3
            type="button"
            className={cn(styles.MainSectionAddButton, buttonClassName, {
              [styles.smallButton]: hasData,
            })}
            onClick={onAdd}
            startIcon="plus"
            variant="contained"
            color="secondary"
            borderRadius={hasData ? 8 : 10}
            size={hasData ? 'small' : undefined}
          >
            {addButtonLabel}
          </ButtonV3>
        ) : null}
      </div>
    </div>
  );
};

SectionWrapper.displayName = 'SectionWrapper';
